import {CartCountEvent, CartUpdateEvent, QuantitySelectorUpdateEvent, ThemeEvents} from '@theme/events';
import {fetchConfig} from "@theme/utilities";

document.addEventListener(ThemeEvents.quantitySelectorUpdate, (event) => {
    const {quantity, line: index} = event.detail;
    const input = event.target;
    const tiers = getTiers(input);
    const itemProperties = getItemProperties(input.dataset.properties);
    const useOjQty = itemProperties._oj_qty !== undefined;

    if (!Array.isArray(tiers)) {
        return;
    }

    const closest = getClosestTier(quantity, tiers);

    if (useOjQty) {
        if (itemProperties._oj_qty === closest) {
            return;
        }
    } else if (closest === quantity) {
        return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!useOjQty) {
        input.value = closest;
        input.dispatchEvent(new QuantitySelectorUpdateEvent(closest, index));

        return;
    }

    updateQuantity(closest, input.dataset.itemKey, itemProperties);
});

document.addEventListener('click', (event) => {
    if (!event.target.matches('hdt-quantity-wrapp button')) {
        return;
    }

    const quantityWrapp = event.target.closest('hdt-quantity-wrapp');
    const input = quantityWrapp.querySelector('input[type="number"]');
    const tiers = getTiers(input);

    if (!Array.isArray(tiers)) {
        return;
    }

    let currentQuantity = parseInt(input.value, 10);
    if (isNaN(currentQuantity)) {
        currentQuantity = 0;
    }

    let newQuantity;

    if (event.target.name === 'minus') {
        const lowerTiers = tiers.filter(t => t < currentQuantity);
        if (lowerTiers.length === 0) {
            newQuantity = currentQuantity;
        } else {
            newQuantity = lowerTiers[lowerTiers.length - 1];
        }
    } else {
        const higherTiers = tiers.filter(t => t > currentQuantity);
        if (higherTiers.length === 0) {
            newQuantity = currentQuantity;
        } else {
            newQuantity = higherTiers[0];
        }
    }

    const step = Math.abs(currentQuantity - newQuantity);
    if (event.target.name === 'minus') {
        input.stepDown(step);
    } else {
        input.stepUp(step);
    }

    quantityWrapp.debouncedOnChange();

    event.preventDefault();
    event.stopImmediatePropagation();
}, true);

function getTiers(input) {
    if (!input.dataset.quantityTiers) {
        return false;
    }

    let tiers
    try {
        tiers = JSON.parse(input.dataset.quantityTiers);
    } catch (e) {
        return false;
    }

    return tiers.map(t => parseInt(t, 10)).filter(t => !isNaN(t)).sort((a, b) => a - b);
}

function getClosestTier(quantity, tiers) {
    let closest = tiers.find(t => t >= quantity);

    if (!closest) {
        closest = tiers[tiers.length - 1];
    }

    return closest;
}

function updateQuantity(quantity, lineKey, itemProperties) {
    const cartItemsComponent = document.querySelector('cart-items-component');
    if (!cartItemsComponent) {
        return;
    }

    cartItemsComponent.classList.add("cart-items-disabled");

    let sectionId = cartItemsComponent.querySelector('[section-id]')?.getAttribute('section-id');
    if (!sectionId) {
        sectionId = cartItemsComponent.closest('[section-id]')?.getAttribute('section-id');

        if (!sectionId) {
            return;
        }
    }

    itemProperties._oj_qty = quantity;

    fetch(`${Shopify.routes.root}cart/change.js`, fetchConfig("json", {
        body: JSON.stringify({
            id: lineKey,
            quantity: quantity > 0 ? 1 : 0,
            sections: sectionId,
            sections_url: window.location.pathname,
            properties: itemProperties,
        }),
    }))
        .then(response => response.json())
        .then(data => {
            document.dispatchEvent(
                new CartUpdateEvent({}, sectionId, data, 'no_action', 'cart-items-component')
            );
        })
        .catch(error => console.error('Error changing quantity:', error))
        .finally(() => {
            cartItemsComponent.classList.remove('cart-items-disabled')
        });
}

function getItemProperties(rawInput) {
    if (!rawInput) {
        return {};
    }

    let parsedData;
    try {
        parsedData = JSON.parse(atob(rawInput));
    } catch (e) {
        parsedData = {};
    }

    let itemProperties = {};
    if (Array.isArray(parsedData)) {
        parsedData.forEach(([key, value]) => {
            itemProperties[key] = value;
        });
    } else {
        itemProperties = parsedData;
    }

    return itemProperties;
}